module.exports = __webpack_public_path__ + "3ddc5b3a50e9a9bb2f77267c389b2580.png";